/**
 * @generated SignedSource<<af1e3b8887d5906ba562c140a3dab6c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participantShortId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shortId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "shortId",
    "variableName": "shortId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "shortId",
    "variableName": "participantShortId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pictureUrl",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 666
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v4/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": "family",
  "args": null,
  "concreteType": "Family",
  "kind": "LinkedField",
  "name": "familyByFamilyId",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v15 = {
  "alias": "partner",
  "args": null,
  "concreteType": "Partner",
  "kind": "LinkedField",
  "name": "partnerByPartnerId",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 16
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyExcerpt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationPageQuery",
    "selections": [
      {
        "alias": "conversation",
        "args": (v2/*: any*/),
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversationByShortId",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Conversation_conversation"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "participant",
        "args": (v3/*: any*/),
        "concreteType": "Participant",
        "kind": "LinkedField",
        "name": "participantByShortId",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Conversation_participant"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConversationPageQuery",
    "selections": [
      {
        "alias": "conversation",
        "args": (v2/*: any*/),
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversationByShortId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displaySubtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": "participants",
            "args": (v7/*: any*/),
            "concreteType": "ParticipantsConnection",
            "kind": "LinkedField",
            "name": "participantsByConversationId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipantsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Participant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "user",
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "userByUserId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": "contact",
                        "args": null,
                        "concreteType": "Contact",
                        "kind": "LinkedField",
                        "name": "contactByContactId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v6/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "participantsByConversationId(first:666)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": "messages",
            "args": (v16/*: any*/),
            "concreteType": "MessagesConnection",
            "kind": "LinkedField",
            "name": "messagesByConversationId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MessagesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "readBy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sender",
                        "storageKey": null
                      },
                      {
                        "alias": "user",
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "userByUserId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": "contact",
                        "args": null,
                        "concreteType": "Contact",
                        "kind": "LinkedField",
                        "name": "contactByContactId",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": "parts",
                        "args": (v7/*: any*/),
                        "concreteType": "PartsConnection",
                        "kind": "LinkedField",
                        "name": "partsByMessageId",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Part",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "order",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mimeType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "body",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedBody",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "content",
                                    "storageKey": null
                                  },
                                  (v18/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "partsByMessageId(first:666)"
                      },
                      {
                        "alias": "parts",
                        "args": (v7/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "Messages_parts",
                        "kind": "LinkedHandle",
                        "name": "partsByMessageId"
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "messagesByConversationId(first:16)"
          },
          {
            "alias": "messages",
            "args": (v16/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Conversation_messages",
            "kind": "LinkedHandle",
            "name": "messagesByConversationId"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "participant",
        "args": (v3/*: any*/),
        "concreteType": "Participant",
        "kind": "LinkedField",
        "name": "participantByShortId",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "associationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "associationType",
            "storageKey": null
          },
          {
            "alias": "contact",
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contactByContactId",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v13/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "conversation",
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversationByConversationId",
            "plural": false,
            "selections": [
              {
                "alias": "userParticipants",
                "args": null,
                "concreteType": "ParticipantsConnection",
                "kind": "LinkedField",
                "name": "participantsByConversationId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Participant",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "user",
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "userByUserId",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "family",
                            "args": null,
                            "concreteType": "Family",
                            "kind": "LinkedField",
                            "name": "familyByFamilyId",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "user",
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userByUserId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "middleName",
                "storageKey": null
              },
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "372854494197a7477135eb36365dde9a",
    "id": null,
    "metadata": {},
    "name": "ConversationPageQuery",
    "operationKind": "query",
    "text": "query ConversationPageQuery(\n  $shortId: String!\n  $participantShortId: String!\n) {\n  conversation: conversationByShortId(shortId: $shortId) {\n    ...Conversation_conversation\n    id\n  }\n  participant: participantByShortId(shortId: $participantShortId) {\n    ...Conversation_participant\n    id\n  }\n}\n\nfragment ChatInput_participant on Participant {\n  associationId\n  associationType\n  user: userByUserId {\n    id\n    firstName\n    middleName\n    lastName\n    pictureUrl\n  }\n}\n\nfragment ConversationHeader_conversation on Conversation {\n  id\n  displayTitle\n  displaySubtitle\n  description\n  type\n  shortId\n  pictureUrl\n  participants: participantsByConversationId(first: 666) {\n    edges {\n      node {\n        user: userByUserId {\n          id\n          firstName\n          lastName\n          pictureUrl\n        }\n        family: familyByFamilyId {\n          id\n          name\n        }\n        contact: contactByContactId {\n          id\n          firstName\n          lastName\n          pictureUrl\n          email\n          phone\n        }\n        partner: partnerByPartnerId {\n          id\n          name\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Conversation_conversation on Conversation {\n  id\n  displayTitle\n  type\n  shortId\n  ...ConversationHeader_conversation\n  ...Messages_viewer\n}\n\nfragment Conversation_participant on Participant {\n  shortId\n  associationId\n  associationType\n  ...SignUpInput_participant\n  ...ChatInput_participant\n}\n\nfragment MessageRow_message on Message {\n  id\n  userId\n  bodyExcerpt\n  createdAt\n  sender\n  user: userByUserId {\n    id\n    pictureUrl\n    name\n    firstName\n    lastName\n    email\n    phone\n  }\n  family: familyByFamilyId {\n    id\n    name\n  }\n  contact: contactByContactId {\n    id\n    pictureUrl\n    firstName\n    lastName\n    email\n    phone\n  }\n  partner: partnerByPartnerId {\n    id\n    name\n  }\n  parts: partsByMessageId(first: 666) {\n    edges {\n      node {\n        id\n        order\n        mimeType\n        body\n        bodyExcerpt\n        formattedBody\n        contentUrl\n        content\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Messages_viewer on Conversation {\n  id\n  shortId\n  title\n  type\n  messages: messagesByConversationId(first: 16) {\n    totalCount\n    edges {\n      node {\n        id\n        createdAt\n        readBy\n        ...MessageRow_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n\nfragment SignUpInput_participant on Participant {\n  shortId\n  contact: contactByContactId {\n    phone\n    email\n    id\n  }\n  conversation: conversationByConversationId {\n    userParticipants: participantsByConversationId {\n      edges {\n        node {\n          user: userByUserId {\n            firstName\n            id\n          }\n          family: familyByFamilyId {\n            name\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "e68f68521c5862dcf260d48844a494b3";

module.exports = node;
